// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex.lg5-custom{width:20%;max-width:20%;flex-basis:20%}.v-dialog{width:unset}.header-padding{padding-top:20px;padding-bottom:10px}.showErrorMsgs{padding-left:30px;color:red!important}", ""]);
// Exports
module.exports = exports;
